import axios from "axios";
import { Auth } from "./firebase";

const serverPath =
  window.location.hostname === "localhost"
    ? "http://127.0.0.1:5001/dh-media-banners-42191/us-central1/bannerMaticApi"
    : "https://us-central1-dh-media-banners-42191.cloudfunctions.net/bannerMaticApi";

export const ApiRequest = async (request) => {
  return Auth.currentUser
    .getIdToken(true)
    .then((idToken) => {
      request = { ...request, idToken };
      return axios.post(serverPath, request);
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw error;
    });
};

export const SearchRequest = async ({ query, id }) => {
  if (!id) id = "3149";
  const path = `https://search.api.tesco.com/search/?query=${query}&offset=0&limit=1000&fields=tpnb,unitprice,price,name,description,image,id,superDepartment,department,aisle,shelf,shelf_1,brand&responseSet=results,totals,filters,popfilters&store=${id}&geo=uk&lang=en&distChannel=ghs&resType=products`;
  return axios
    .post(path)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log("SearchRequest error", error);
      const msg = error.response ? error.response : error.message;
      throw msg;
    });
};

//export const TpnbRequest = (tpnb, id) => {
//  if (!id) id = "3060";
//  return new Promise(async (resolve, reject) => {
//    const path = `https://search.api.tesco.com/browse/?offset=0&limit=10&fields=tpnb,price,name,image,id,superDepartment,department,aisle,shelf,shelf_1,PromotionDescription,PromotionId,PromotionIcon,PromotionStart,PromotionEnd,availability,new,offer,brand,DeliveryRestrictions,promotions&tpnb=${tpnb}&store=${id}&geo=uk&distChannel=ghs&resType=products`;
//    await axios
//      .post(path)
//      .then((response) => {
//        console.log("TpnbRequest", response);
//        let data = { error: "Product not found" };
//        if (response.data.uk.ghs.products.totals.all !== 0)
//          data = response.data.uk.ghs.products.results[0];
//        return resolve(data);
//      })
//      .catch((err) => {
//        console.log(err);
//        return reject(err);
//      });
//  });
//};

//export const SpectraRequest = async (request) => {
//  const spectra =
//    "https://us-central1-ghs-trade-banners.cloudfunctions.net/spectra";
//  return axios
//    .post(spectra, request)
//    .then((response) => {
//      console.log("SpectraRequest response", response.data);
//      return response.data;
//    })
//    .catch((error) => {
//      throw error;
//    });
//};
